import {
  EnrollmentProposition,
  NewPropositionStateType
} from '../../lib/types/models/enrollment-proposition/enrollment-proposition'
import { EnrollmentPropositionRequest } from '../../lib/types/models/enrollment-proposition/enrollment-proposition-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateEnrollmentProposition(
  data: UpdateInput<EnrollmentPropositionRequest> & { enrollmentId: number }
) {
  const { id, enrollmentId, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.updateProposition.url, {
        id: enrollmentId,
        propositionId: id
      })
    )
    .patch<EnrollmentProposition, Partial<EnrollmentPropositionRequest>>(rest)
}

export function newPropositionState(
  data: UpdateInput<EnrollmentPropositionRequest> & { enrollmentId: number }
) {
  const { id, enrollmentId, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.newPropositionState.url, {
        id: enrollmentId,
        propositionId: id
      })
    )
    .patch<{ state: NewPropositionStateType }, Partial<EnrollmentPropositionRequest>>(rest)
}
